import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "dataTestId", "onClick", "tooltip", "tooltipPlacement", "tooltipUse", "showNewBadge", "disabled", "size"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PropTypes from 'prop-types';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionButton = _ref => {
  let {
      label,
      dataTestId,
      onClick,
      tooltip,
      tooltipPlacement = 'left bottom',
      tooltipUse = 'default',
      showNewBadge,
      disabled,
      size
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    use,
    href,
    target,
    external
  } = buttonProps;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled,
    title: tooltip,
    use: tooltipUse,
    placement: tooltipPlacement,
    children: /*#__PURE__*/_jsxs(Button, {
      disabled: disabled,
      onClick: onClick,
      "data-test-id": dataTestId,
      use: use,
      size: size,
      href: href,
      target: target,
      external: external,
      children: [/*#__PURE__*/_jsx(TruncateString, {
        inlineSize: "max-content",
        children: label
      }), showNewBadge && /*#__PURE__*/_jsx(Badge, {
        use: "new",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.newBadge"
        })
      })]
    })
  });
};
ActionButton.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.node,
  tooltipUse: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  showNewBadge: PropTypes.bool
};
export default ActionButton;